import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetAllHeadings,
  GetHeadingById,
  CreateHeading,
  EditHeading,
  DeleteHeading,
} from "../../services/headings"; // Adjust the path if needed

// ──────────────────────────────
// Initial State
// ──────────────────────────────
const initialState = {
  headings: [],
  loading: false,
  error: null,
};

// ──────────────────────────────
// Slice
// ──────────────────────────────
const headingSlice = createSlice({
  name: "headings",
  initialState,
  reducers: {
    setHeading: (state, { payload }) => {
      state.headings = payload;
    },
    removeSingleHeading: (state, { payload }) => {
      state.headings = state.headings.filter((i) => i.id !== payload);
    },
  },
  extraReducers: (builder) => {
    builder
      // ───── GET ALL ─────
      .addCase(getAllHeadingsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllHeadingsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.headings = action.payload;
      })
      .addCase(getAllHeadingsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // ───── CREATE ─────
      .addCase(createHeadingAsync.fulfilled, (state, action) => {
        state.headings.push(action.payload);
      })

      // ───── EDIT ─────
      .addCase(editHeadingAsync.fulfilled, (state, action) => {
        const index = state.headings.findIndex(
          (h) => h.id === action.payload.id
        );
        if (index !== -1) {
          state.headings[index] = {
            ...state.headings[index],
            ...action.payload.updated,
          };
        }
      })

      // ───── DELETE ─────
      .addCase(deleteHeadingAsync.fulfilled, (state, action) => {
        state.headings = state.headings.filter((h) => h.id !== action.payload);
      });
  },
});

// ──────────────────────────────
// Async Thunks
// ──────────────────────────────

export const getAllHeadingsAsync = createAsyncThunk(
  "headings/getAllHeadingsAsync",
  async () => {
    const response = await GetAllHeadings();
    return response;
  }
);

export const createHeadingAsync = createAsyncThunk(
  "headings/createHeadingAsync",
  async (payload) => {
    const response = await CreateHeading(payload);
    return response;
  }
);

export const editHeadingAsync = createAsyncThunk(
  "headings/editHeadingAsync",
  async ({ id, payload }) => {
    const response = await EditHeading(id, payload);
    return { id, updated: response };
  }
);

export const deleteHeadingAsync = createAsyncThunk(
  "headings/deleteHeadingAsync",
  async (id) => {
    await DeleteHeading(id);
    return id;
  }
);

// ──────────────────────────────
// Exports
// ──────────────────────────────

export const { setHeading, removeSingleHeading } = headingSlice.actions;

export default headingSlice.reducer;
